var t=()=>{try{return new Function('import("")'),!0}catch{return!1}},r=()=>"ontouchstart"in window||navigator.maxTouchPoints>0;export{t as a,r as b};
//# sourceMappingURL=chunk.UUY56XFY.js.map
